import React from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";
import { ownerApi } from "../../../../api/owner";
import { formatApiError } from "../../../../api/client";

// WP-STANDARD | OWNER DAY CLOSE
// Status: PATCH-4 · EXPLICIT-ROLLOVER · NO-SILENT-REPLANNING · SYNTAX-REVIEWED · v1
// Closing the day records a fact and forces an explicit decision for unfinished
// scheduled work. Waiting/blocked work is already controlled and is never moved.
export default function OwnerDayCloseDialog({ open, onClose, calendar, onSaved }) {
  const [rollover,setRollover]=React.useState("keep");
  const [note,setNote]=React.useState("");
  const [saving,setSaving]=React.useState(false);
  const [error,setError]=React.useState("");
  React.useEffect(()=>{ if(open){ setRollover("keep"); setNote(""); setError(""); } },[open]);
  const lifecycle=calendar?.day?.lifecycle || {};
  const unresolved=Number(lifecycle?.closure?.unresolved || 0);
  const submit=async()=>{
    if(saving)return;
    setSaving(true); setError("");
    try{
      await ownerApi.closeOwnerDay({ date:calendar?.selectedDate, note, rollover });
      await onSaved?.(); onClose?.();
    }catch(err){ setError(formatApiError(err,"No pude cerrar el día.")); }
    finally{ setSaving(false); }
  };
  return <Dialog open={open} onClose={saving?undefined:onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{fontWeight:1000}}>Cerrar el día</DialogTitle>
    <DialogContent sx={{pt:"8px !important"}}><Stack spacing={1.2}>
      {error?<Alert severity="error">{error}</Alert>:null}
      <Typography sx={{fontSize:".82rem",fontWeight:850}}>Resultado actual: {Number(lifecycle?.score || 0)}%{lifecycle?.won ? " · día ganado" : ""}</Typography>
      <Typography sx={{fontSize:".7rem",color:"text.secondary"}}>Quedan {unresolved} compromisos accionables sin cerrar. Las esperas y bloqueos ya cuentan como controlados.</Typography>
      <RadioGroup value={rollover} onChange={(event)=>setRollover(event.target.value)}>
        <FormControlLabel value="keep" control={<Radio size="small"/>} label={<><b>Dejarlos donde están</b><Typography component="span" sx={{display:"block",fontSize:".64rem",color:"text.secondary"}}>No modifico agenda. Mañana decidís conscientemente qué hacer.</Typography></>}/>
        <FormControlLabel value="tomorrow" control={<Radio size="small"/>} label={<><b>Pasar lo programado a mañana</b><Typography component="span" sx={{display:"block",fontSize:".64rem",color:"text.secondary"}}>Sólo mueve tareas con horario; mantiene la hora y no toca esperas/bloqueos.</Typography></>}/>
      </RadioGroup>
      <TextField label="Nota de cierre (opcional)" multiline minRows={2} value={note} onChange={(event)=>setNote(event.target.value)} inputProps={{maxLength:1000}} placeholder="Qué quedó claro, qué aprendiste o qué necesita contexto mañana."/>
    </Stack></DialogContent>
    <DialogActions><Button onClick={onClose} disabled={saving}>Cancelar</Button><Button variant="contained" onClick={submit} disabled={saving}>{saving?"Cerrando…":"Cerrar día"}</Button></DialogActions>
  </Dialog>;
}
